const { Interval, DateTime } = require("luxon");

const { SLOT_BLOCK_REASON } = require("../constants");
const getScheduledSlots = require("./getScheduledSlots");

function getInterval(startTime, duration, endTime) {
  const start = startTime;
  const end = endTime
    ? endTime
    : start.plus({
        minutes: duration,
      });

  return Interval.fromDateTimes(start, end);
}

function markSlotsWithPaxLimit(slots, pax, duration) {
  const slotsOrig = [...slots];

  return slots.map((slot) => {
    const reservationInterval = getInterval(slot.start, duration);
    const hasOverlaps = slotsOrig.some((slot) => {
      const slotInterval = getInterval(slot.start, null, slot.end);
      const overlaps = reservationInterval.overlaps(slotInterval);
      const exceeds = Number(pax) + slot.currentPax > slot.maxCapacity;
      if (overlaps && exceeds) {
        return true;
      } else {
        return false;
      }
    });
    const available = hasOverlaps ? false : slot.available;
    let reason = null;
    if (!available && slot.available) {
      if (slot.currentPax >= slot.maxCapacity) {
        reason = SLOT_BLOCK_REASON.PAX_LIMIT;
      } else {
        reason = SLOT_BLOCK_REASON.BOOKING_DURATION_LIMIT;
      }
    }

    return { ...slot, available, ...(reason && { reason }) };
  });
}

module.exports = async (firebase, business, date, pax, duration) => {
  let slots = await getScheduledSlots(firebase, business, date, duration);
  const newSlots = markSlotsWithPaxLimit(slots, pax, duration);
  const bookingStart = DateTime.fromJSDate(date);
  const bookingEnd = bookingStart.plus({ minutes: duration });
  const filtered = newSlots.filter((slot) => {
    return slot.start < bookingEnd && slot.end > bookingStart;
  });
  return filtered;
};
